import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';

import type { NotificationProps } from '~/shared/components/Notification';
import { api } from '~/shared/services/api';

function updateLanguage(language: string) {
  return api.put(
    `/api/user-access-management/employees/preferred-language/${language}`
  );
}

export function useUpdateLanguage(
  showNotification?: (notification: Omit<NotificationProps, 'onClose'>) => void
) {
  const { t } = useTranslate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLanguage,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['preferred-language'] });
      if (showNotification) {
        showNotification({
          title: t(
            'languages.preferred_language.notification.success.title',
            'Language Changed'
          ),
          message: t(
            'languages.preferred_language.notification.success.message',
            'Language changed successfully'
          ),
          variant: 'notification',
          autoDismiss: true,
          timeout: 5000
        });
      }
    },
    onError: async () => {
      if (showNotification) {
        showNotification({
          title: t(
            'languages.preferred_language.notification.error.title',
            'Error'
          ),
          message: t(
            'languages.preferred_language.notification.error.message',
            'Failed to change language. Please try again.'
          ),
          variant: 'error',
          autoDismiss: true,
          timeout: 5000
        });
      }
    }
  });
}
